import MultiTripSeatSelector from './MultiTripSeatSelector';

export default MultiTripSeatSelector;
